import React from 'react';

import { Link3Outline } from '@lyearn/icons';
import {
  AdaptedLinkTab,
  AdaptedMenuTab,
} from '@/components/Header/components/NavigationTabs/types';
import { Image } from '@/components/Image';
import { SidebarItems, SidebarSection } from '@/modules/corporate/modules/admin/hooks/useSidebar';
import { NavbarElementTypeEnum } from '@/types/schema';

import { NAV_SECTION_IDS } from '../consts';

export const CUSTOM_LINKS_SECTION_ID = 'custom-links';

const renderCustomLinkIcon = (src?: string) =>
  src ? (
    <Image alt="" className="h-18 w-18 rounded-4 object-cover" height={18} src={src} width={18} />
  ) : (
    <Link3Outline className="h-18 w-18" />
  );

export function toCustomLinksSidebarSection(
  tabs: (AdaptedLinkTab | AdaptedMenuTab)[],
): SidebarSection | null {
  if (!tabs.length) {
    return null;
  }

  return {
    id: CUSTOM_LINKS_SECTION_ID,
    // Every custom link shares the `customLink` key, so ids are positional
    children: tabs.map((tab, index) => {
      const id = `${CUSTOM_LINKS_SECTION_ID}-${index}`;

      if (tab.type === NavbarElementTypeEnum.Link) {
        return {
          id,
          text: tab.label,
          icon: renderCustomLinkIcon(tab.icon),
          to: tab.to,
          enabled: true,
        };
      }

      return {
        id,
        text: tab.label,
        icon: renderCustomLinkIcon(tab.icon),
        enabled: true,
        children: tab.children.map((child, childIndex) => ({
          id: `${id}-${childIndex}`,
          text: String(child.label ?? ''),
          to: child.asProps.to,
          enabled: true,
          groupId: id,
        })),
      };
    }),
  };
}

// Custom links sit after the built-in sections, just above the footer (Settings)
export function withCustomLinksSection(
  sidebarItems: SidebarItems,
  section: SidebarSection | null,
): SidebarItems {
  if (!section) {
    return sidebarItems;
  }

  const footerIndex = sidebarItems.findIndex(({ id }) => id === NAV_SECTION_IDS.Footer);

  return footerIndex === -1
    ? [...sidebarItems, section]
    : [...sidebarItems.slice(0, footerIndex), section, ...sidebarItems.slice(footerIndex)];
}
